import {
    HttpClient,
    HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    Observable,
    throwError
} from "rxjs";
import {
    catchError,
    map
} from "rxjs/operators";
import {
    FaqModel
} from "../domain";
import { ApiEndpointService } from "./api-endpoint.service";

@Injectable({
    providedIn: "root"
})
export class FaqService {

    constructor(private http: HttpClient) {

    }

    public getAllFaq(): Observable<any> {
        const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.GET_FAQ);
        return this.http.get(url).pipe(
            map((response: any) => {
                return response.data;
                }),
                catchError((fault: HttpErrorResponse) => {
                console.warn(`loginFault( ${fault.error?.message || fault.message || fault.status} )`);
                return throwError(() => fault);
            })
        );
    }

}
